<template>
  <div class="popup">
    <div class="popup-header">
      {{ $t("titles.contact") }} {{ user_set.length }} {{ $t("titles.users") }}
      <div class="popup-close" @click="$emit('close')">
        <font-awesome-icon icon="times" />
      </div>
    </div>
    <div class="popup-body">
      <b-container fluid>
        <div class="form-row">
          <div class="col-3">
            {{ $t("labels.emailsendersname") }}
          </div>
          <div class="col-8">
            <v-select v-if="useazure" :options="this.authemailsenders" label="name" v-model="sender" />
            <v-select v-if="usesmtp" :options="this.emailsenders" label="name" v-model="sender" />
          </div>
        </div>
        <div class="form-row">
          <div class="col-3">
            {{ $t("titles.subject") }}
          </div>

          <div class="col-8">
            <b-input :state="subject != null && subject != ''" v-model="subject" required :placeholder="$t('titles.subject')" />
          </div>
        </div>
        <div class="form-row">
          <div class="col-3"></div>
          <div class="col-8">
            {{ $t("templates.searchemail") }}
          </div>
        </div>
        <div id="app" :style="ckeditorState(editorData)">
          <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor>
        </div>
      </b-container>
    </div>
    <div class="popup-footer">
      <div @click="save_and_close" class="btn btn-primary"><font-awesome-icon icon="envelope" /> {{ $t("buttons.sendmessage") }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "axios";
// const querystring = require("querystring");

export default {
  name: "mail_search_modal",
  data() {
    return {
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        toolbar: {
          items: ["heading", "|", "undo", "redo", "-", "|", "bold", "italic", "link", "bulletedList", "numberedList", "blockQuote", "insertTable"],
          shouldNotGroupWhenFull: true,
        },
        heading: {
          options: [
            { model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" },
            { model: "heading1", view: "h1", title: "Heading 1", class: "ck-heading_heading1" },
            { model: "heading2", view: "h2", title: "Heading 2", class: "ck-heading_heading2" },
          ],
        },
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
        },
        placeholder: this.$t("labels.message"),
      },
      subject: "",
      selected: [],
      sender: 0,
    };
  },
  props: {
    user_set: Array,
  },

  mounted() {},
  computed: {
    ...mapGetters(["planning_by_id", "project_by_id", "contract_by_id", "contracts_metas", "contract_new", "username_by_id", "user_by_id", "company_by_id", "activeemailsenders", "useazure", "usesmtp"]),
    ...mapState(["users", "settings", "contracts", "current_user", "documents", "authemailsenders", "emailsenders"]),
  },
  methods: {
    async save_and_close() {
      let index = 0;
      while (index < this.user_set.length) {
        let message = {};
        message.email = this.user_set[index].email;
        message.name = this.user_set[index].fullname;
        message.message = this.editorData.replaceAll(/\[voornaam\]/gi, this.user_set[index].firstname);
        message.subject = this.subject;
        message.sender = this.sender ? this.sender.id : -1;
        message.sendermail = this.sender ? this.sender.email : -1;
        message.sendername = this.sender ? this.sender.name : -1;

        console.log(message, index);
        try {
          await axios.post("/api/contact_user", message).then((response) => {
            console.log("succes", response);
            index++;
          });
        } catch (err) {
          console.log(err);
        }
      }
      this.$emit("close");

      /*          let email = this.user.email
          let name = this.user.fullname
          let message = {}
          message.email = email
          message.name = name
          message.message = this.editorData
          message.subject = this.subject


          */
    },
    ...mapActions([]),
  },
};
</script>
